import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import { handleError, handleResponse } from '@/services/api/utils/response.js'
import axios from 'axios'

const url = 'data-elements'
const plural = 'dataelements'
const single = 'dataelement'

const api = new ApiCore({
	index: true,
	findOne: true,
	findAll: true,
	create: false,
	update: false,
	remove: false,
	url: url,
	plural: plural,
	single: single
})

api.getDataElementDetails = ({ params }) => {
	const { dataElementId, useCaseId, type, ...others } = params
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/${dataElementId}/enrolments/${useCaseId}/${type.toUpperCase()}`, { params: others })
		.then(handleResponse)
		.catch(handleError);
}

export default api
